import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { MtProjectGroup, MtProjectGroupCreate } from "server/models"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    ProjectGroupValidation,
    SaveProjectGroup,
    closeModal,
    setProjectGroupEdit,
    setProjectGroupReloadList,
    setProjectGroupReloadEdit,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
    SpinnerIcon,
    Textarea,
} from "client/components"

interface EditProjectGroupProps {
    group: MtProjectGroup
    editAccess: boolean
}

let isMounted: boolean

const Form = ({
    group,
    editAccess,
}: EditProjectGroupProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(group.name)
    const [description, setDescription] = useInput(group.description)

    const [validation, setValidation] = useState<ProjectGroupValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (modals.length && isMounted) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newGroupData: MtProjectGroupCreate = {
            groupId: group.groupId || null,
            accountId: group.accountId || project.accountId,
            projectId: group.projectId || project.id,
            name,
            description,
            creator: group.groupId ? group.creator : userData.userId,
            default: group.default,
            order: group.groupId ? group.order : 0,
        }

        SaveProjectGroup(newGroupData, lang)
        .then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setProjectGroupEdit({
                ...newGroupData,
                groupId: res.newGroupId || group.groupId,
                order: res.newGroupOrder || group.order,
            }))

            dispatch(setProjectGroupReloadList(false))
            setTimeout(() => {
                dispatch(setProjectGroupReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setProjectGroupReloadEdit(false))
                setTimeout(() => {
                    dispatch(setProjectGroupReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} readOnly={!editAccess} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} readOnly={!editAccess} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    {
                        editAccess && ([
                            <Button key="saveButton" variant="success" row onClick={() => onSave(1)}>
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>,
                            <Button key="applyButton" variant="success" row onClick={() => onSave(2)}>
                                {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                            </Button>,
                        ])
                    }
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
